module.exports = __webpack_public_path__ + "static/media/chat-bg-transparent.a4be512e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nadubot/chat-bg-transparent.png
// module id = 6179
// module chunks = 0